import { useState, useRef, useLayoutEffect } from 'react';
import { Typography, Box } from '../../base';
import PargodaModal from '../PargodaModal';
import { useTranslation } from 'react-i18next';
import {
    ReadMoreButton,
    ContentWrapper,
    TruncatedTypography,
} from './TextWithReadMore.styles';

interface Props {
    text: string;
    title: string;
}

const TextWithReadMore = (props: Props) => {
    const { text, title } = props;
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showReadMore, setShowReadMore] = useState(false);
    const textRef = useRef<HTMLParagraphElement>(null);

    useLayoutEffect(() => {
        if (textRef.current) {
            const { scrollHeight, clientHeight } = textRef.current;
            if (scrollHeight > clientHeight) {
                setShowReadMore(true);
            }
        }
    }, [text]);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    return (
        <ContentWrapper>
            <Typography variant="subtitle1">{title}</Typography>
            <TruncatedTypography variant="body2" ref={textRef}>
                {text}
            </TruncatedTypography>
            {showReadMore && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ReadMoreButton variant="text" onClick={handleOpenModal}>
                        {t('jobApplicationPage.readMore')}
                    </ReadMoreButton>
                </Box>
            )}
            <PargodaModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                modalTitle={title}
            >
                <Box>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                        {text}
                    </Typography>
                </Box>
            </PargodaModal>
        </ContentWrapper>
    );
};

export default TextWithReadMore;
